import _get from 'lodash/get'
import _has from 'lodash/has'
import _isEmpty from 'lodash/isEmpty'

export class QuickbuyVerificationRecord {
  constructor (record) {
    this._record = record

    this.documents = {
      selfie: _get(record, 'data.quickbuyUserdata.selfie'),
      documentImages: _get(record, 'data.quickbuyUserdata.documentImages'),
    }

    this.id = _get(record, 'id', '')
    this.rememberMeId = _get(record, 'rememberMeId', '')
    this.type = _get(record, 'type', '')
    this.status = _get(record, 'status', '')
    this.data = _get(record, 'data') || {}
    this.reason = _get(record, 'reason') || {}

    if (this.isNotEmptyData) {
      if (_has(this.data, 'quickbuyUserdata')) {
        delete this.data.quickbuyUserdata.selfie
        delete this.data.quickbuyUserdata.documentImages
      }
    }
  }

  get isNotEmptyData () {
    return !_isEmpty(this.data)
  }

  get isNotEmptyReason () {
    return !_isEmpty(this.reason)
  }

  get isNotEmptySelfie () {
    return !_isEmpty(this.documents.selfie)
  }

  get isNotEmptyDocImages () {
    return !_isEmpty(this.documents.documentImages)
  }
}
